import { Tooltip } from "@mui/material";
import { useState } from "react";
import { Popover } from "antd";

const SwitchButton = (props) => {
  const [switchTab, setSwitchTab] = useState(props.right ? true : false);
  const handleSwitch = () => {
    const updatedState = !switchTab;
    setSwitchTab(updatedState);
    props.handleSwitchButton(updatedState);
  };
  let infoText = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <ul className="pl-[15px]">
        <li className="list-disc text-[12px]"> LT = Lowest Tier</li>
        <li className="list-disc text-[12px]"> HT = Higher Tier</li>
      </ul>
      <p className="my-[7px] text-[12px]">
        Most banks, finance and in-house loan providers have a 2 or more
        interest rate for their loan product. We have organise them under LT &
        HT for your ease of information when using our portal.
      </p>
    </div>
  );
  return (
    <div className="inline-flex items-center mr-[33px] mb-[20px] min-[601px]:absolute min-[601px]:bottom-0 min-[601px]:right-[-17px] max-[600px]:mt-[10px]">
      <div className="p-[3px] text-white text-[13px] font-[600] bg-[#0F59F9] rounded-[4px] relative">
        <span className="inline-block py-[3px] px-[10px]">LT</span>
        <span className="inline-block py-[3px] px-[10px]">HT</span>
        <span
          className={`cursor-pointer switch_wt_bx absolute top-[50%] -translate-y-[50%] ${
            switchTab ? "right-[3px]" : "right-[53%]"
          } h-[85%] w-[44%] bg-white rounded-[4px]`}
          onClick={handleSwitch}
        ></span>
      </div>

      <Popover content={infoText} placement="top">
        <img src="/images/fi_info.svg" alt="info" className="ml-[10px]" />
      </Popover>
    </div>
  );
};

export default SwitchButton;
